import { useMemo } from 'react';

import { useDecisionMakerResponsePageData } from '#src/app/pages/decisionMaker/response/details/pageContext';

type Data = {
	responseId: string;
	dmId: string;
	dmPubliclyVisible: string;
	dmIsPerson: string;
	petitionId: string;
	petitionStatus: string;
	petitionPromotable: string;
	starterId: string;
	urls: {
		petitionDmResponses: string;
		allDmResponses: string;
		selfServiceResponses: string;
		dmAdmin: string;
		dmEdit: string;
		dmAdminAccounts: string;
		petitionAdmin: string;
		petitionDashboard: string;
		userAdmin: string;
	};
};

type Result = ModelHookResult<Data>;

const yesNo = (value: boolean) => (value ? 'Yes' : 'No');

export function useDmResponseStaffDrawer(): Result {
	const {
		data: {
			decisionMakerResponse: { id, decisionMaker, petition },
		},
	} = useDecisionMakerResponsePageData();

	const urls = useMemo(() => {
		const encodedPetitionSlug = encodeURIComponent(petition.slug);
		const encodedDmSlugOrId = encodeURIComponent(decisionMaker.slug || decisionMaker.id);
		const dmAdmin = `/admin/decision-makers/${encodedDmSlugOrId}`;
		const petitionAdmin = `/admin/p/${encodedPetitionSlug}`;
		return {
			petitionDmResponses: `${petitionAdmin}/dm_responses`,
			allDmResponses: '/admin/decision-makers/responses',
			selfServiceResponses: '/admin/decision-makers/self-service-responses',
			dmAdmin,
			dmEdit: `${dmAdmin}/edit`,
			dmAdminAccounts: `${dmAdmin}/admin_accounts`,
			petitionAdmin,
			petitionDashboard: `/p/${encodedPetitionSlug}/dashboard`,
			userAdmin: `/admin/u/${petition.user.id}`,
		};
	}, [petition.slug, petition.user.id, decisionMaker.slug, decisionMaker.id]);

	return {
		data: {
			responseId: id,
			dmId: decisionMaker.id,
			dmPubliclyVisible: yesNo(decisionMaker.publiclyVisible),
			dmIsPerson: yesNo(decisionMaker.isPerson),
			petitionId: petition.id,
			petitionStatus: petition.status,
			petitionPromotable: yesNo(petition.promotable),
			starterId: petition.user.id,
			urls,
		},
	};
}
